export default "__VITE_ASSET__BcURoFnb__"